import { useQuery } from "@tanstack/react-query";
import adminApiClient, { KlydoStatsResponse } from "api/admin";

export default function useKlydoStats() {
  return useQuery<KlydoStatsResponse>({
    queryKey: ["klydoStats"],
    queryFn: () => adminApiClient.getKlydoStats(),
  });
}
